// extracted by mini-css-extract-plugin
module.exports = {"root":"cafes-restaurants-page_root__F0jvi"};